// @flow

import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadSoloistsAction } from '../../actions/soloist';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +loadedCursors: { [key: string]: boolean },
    +entities: Array<number>,
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function soloists(state: State = initialState, action: LoadSoloistsAction) {
  if (action.type === 'FETCH_SOLOISTS' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
